<template>
  <div class="container-fluid mt-4" :class="themeClass">
    <div class="card shadow-sm">
      <div class="card-header">
        <h5 class="mb-0">
          <i class="bi bi-person-plus me-2"></i>
          Nuevo Empleado
        </h5>
      </div>
      <div class="card-body">
        <div v-if="error" class="alert alert-danger" role="alert">
          <i class="bi bi-exclamation-triangle me-2"></i>
          {{ error }}
        </div>

        <form @submit.prevent="guardarEmpleado">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Nombres</label>
              <input v-model="empleado.first_name" type="text" class="form-control" required />
            </div>
            <div class="col-md-6">
              <label class="form-label">Apellidos</label>
              <input v-model="empleado.last_name" type="text" class="form-control" required />
            </div>

            <div class="col-md-4">
              <label class="form-label">Tipo de identificación</label>
              <select v-model="empleado.identification_type_sri_code" class="form-select" required>
                <option value="05">Cédula</option>
                <option value="04">RUC</option>
                <option value="06">Pasaporte</option>
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label">Identificación</label>
              <input v-model="empleado.identification_number" type="text" class="form-control" required />
            </div>
            <div class="col-md-4">
              <label class="form-label">Rol</label>
              <select v-model="empleado.role" class="form-select" required>
                <option value="administrador">Administrador</option>
                <option value="vendedor">Vendedor</option>
                <option value="operador">Operador</option>
              </select>
            </div>

            <div class="col-md-6">
              <label class="form-label">Email</label>
              <input v-model="empleado.email" type="email" class="form-control" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Teléfono</label>
              <input v-model="empleado.phone" type="text" class="form-control" />
            </div>

            <div class="col-12">
              <label class="form-label">Dirección</label>
              <input v-model="empleado.address" type="text" class="form-control" />
            </div>

            <div class="col-12">
              <div class="form-check">
                <input v-model="empleado.is_active" class="form-check-input" type="checkbox" id="empleadoActivo" />
                <label class="form-check-label" for="empleadoActivo">Empleado activo</label>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-end gap-2 mt-4">
            <router-link to="/personas/empleados" class="btn btn-outline-secondary">
              <i class="bi bi-arrow-left me-1"></i>
              Volver
            </router-link>
            <button type="submit" class="btn btn-primary" :disabled="guardando">
              <i class="bi bi-save me-1"></i>
              {{ guardando ? 'Guardando...' : 'Guardar' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import themeManager from '@/store/theme'
import { employeeService } from '@/services/employeeService'

export default {
  name: 'ClientPersonalNuevo',
  computed: {
    themeClass() {
      return themeManager.themeClass
    }
  },
  data() {
    return {
      empleado: {
        first_name: '',
        last_name: '',
        identification_type_sri_code: '05',
        identification_number: '',
        email: '',
        phone: '',
        address: '',
        role: 'vendedor',
        is_active: true
      },
      guardando: false,
      error: null
    }
  },
  methods: {
    buildPayload() {
      const businessName = `${this.empleado.first_name} ${this.empleado.last_name}`.trim()
      return {
        first_name: this.empleado.first_name,
        last_name: this.empleado.last_name,
        business_name: businessName,
        identification_type_sri_code: this.empleado.identification_type_sri_code,
        identification_number: this.empleado.identification_number,
        email: this.empleado.email,
        phone: this.empleado.phone,
        address: this.empleado.address,
        role: this.empleado.role,
        is_active: this.empleado.is_active,
        is_employee: 1
      }
    },
    async guardarEmpleado() {
      this.guardando = true
      this.error = null
      try {
        await employeeService.createEmployee(this.buildPayload())
        this.$router.push('/personas/empleados')
      } catch (error) {
        console.error('Error al crear empleado:', error)
        this.error = 'No se pudo guardar el empleado.'
      } finally {
        this.guardando = false
      }
    }
  }
}
</script>


